var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var SecurityMatrixService = /** @class */ (function (_super) {
            __extends(SecurityMatrixService, _super);
            function SecurityMatrixService(injectedBreeze, $q, $http, modalService) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.modalService = modalService;
                return _this;
            }
            SecurityMatrixService.prototype.createSecurityMatrix = function (isSystemLevel, alwaysVisible) {
                var obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);
                obj.matrixType = 1 /* HideOrShow */;
                obj.usesAnotherSecurityMatrix = false;
                return obj;
            };
            SecurityMatrixService.prototype.internalCreateSecurityMatrix = function (isSystemLevel, alwaysVisible) {
                var obj = this.createNewEntity("SecurityMatrix");
                obj.isSystemLevel = isSystemLevel;
                obj.uniqueIdentifier = services.UtilityService.generateGuidComb();
                if (alwaysVisible) {
                    obj.alwaysVisible = alwaysVisible;
                }
                else {
                    obj.alwaysVisible = false;
                }
                return obj;
            };
            SecurityMatrixService.prototype.getSystemLevelSecurityMatrices = function () {
                var query = this.breezeModule.EntityQuery
                    .from("SecurityMatrixs")
                    .where('systemLevel_id', '!=', null);
                return this.executeQuery(query);
            };
            SecurityMatrixService.prototype.getProcessConfigurationSecurityMatrices = function (processConfigurationId) {
                var query = this.breezeModule.EntityQuery
                    .from("SecurityMatrices")
                    .where('processConfiguration_id', '==', processConfigurationId)
                    .expand('claimBindings');
                return this.executeQuery(query);
            };
            SecurityMatrixService.prototype.createAdvancedSecurityMatrix = function (isSystemLevel, alwaysVisible) {
                var obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);
                obj.matrixType = 2 /* HideOrReadOnlyOrUpdateable */;
                obj.usesAnotherSecurityMatrix = false;
                return obj;
            };
            SecurityMatrixService.prototype.createSecurityRow = function (isSystemLevel, alwaysVisible) {
                var obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);
                obj.matrixType = 3 /* SecurityRow */;
                obj.usesAnotherSecurityMatrix = false;
                return obj;
            };
            SecurityMatrixService.prototype.createSecurityRowWithSubTypes = function (isSystemLevel, alwaysVisible) {
                var obj = this.internalCreateSecurityMatrix(isSystemLevel, alwaysVisible);
                obj.matrixType = 4 /* SecurityRowWithSubType */;
                obj.usesAnotherSecurityMatrix = false;
                return obj;
            };
            SecurityMatrixService.prototype.openSecurityMatrixModal = function (securityMatrix, processConfigurationId, currentStateUniqueId) {
                var self = this;
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/securityMatrixModal.html",
                    controller: "securityMatrixModalController",
                    inputs: {
                        processConfigurationId: processConfigurationId,
                        securityMatrix: securityMatrix,
                        currentStateUniqueId: currentStateUniqueId
                    }
                })
                    .then(function (modal) {
                    modal.element.modal();
                    modal.close.then(function (result) {
                        $('.modal-backdrop')
                            .each(function () {
                            $(this).remove();
                        });
                        if (result) {
                            self.saveAllChanges();
                        }
                        else {
                            self.rejectChanges();
                        }
                    });
                });
            };
            SecurityMatrixService.prototype.getSecurityMatrixView = function (securityMatrixId) {
                var _this = this;
                var params = {};
                var handlerUrl = "api/SecurityMatrix/" + securityMatrixId + "/View";
                var result = this.$http.get(handlerUrl, params)
                    .then(function (response) { return _this.handlerResponded(response, params); });
                return result;
            };
            SecurityMatrixService.prototype.openViewSecurityMatrixModal = function (securityMatrixId) {
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/viewSecurityMatrixModal.html",
                    controller: "viewSecurityMatrixModalController",
                    size: 'lg',
                    inputs: {
                        securityMatrixId: securityMatrixId
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) { });
                });
            };
            SecurityMatrixService.prototype.handlerResponded = function (response, params) {
                response.data.requestParams = params;
                return response.data;
            };
            return SecurityMatrixService;
        }(services.DataService));
        services.SecurityMatrixService = SecurityMatrixService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('SecurityMatrixService', ['breeze', '$q', "$http", 'ModalService']);
